import { VideoIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const VideoPlay = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <VideoIcon size={Sizes[size]} color={fill} {...rest} />;
};

VideoPlay.displayName = 'VideoPlay';
